
import axios from "axios";
import appconst from "@/lib/appconst";
import { Component, Vue } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import ImageUploader from '../../../components/uploader/imageUploader.vue'

import { TenantDto } from "@/api/service-proxies";
import { schoolService } from "@/api/multi-tenancy/tenant";

import PagedListBase, {
  PagedRequestDto
} from "@/lib/view-base/paged-list-base";

class TenantPagedRequest extends PagedRequestDto {
  name!: string;
  isHaveSignCode!: boolean
}

@Component({
  name: "Tenant",
  components: {
    Pagination,
    ImageUploader
  }
})
export default class Tenant extends PagedListBase<
  TenantPagedRequest,
  TenantDto
> {
  request = new TenantPagedRequest();
  dialogVisible = false
  currentTenant = new TenantDto();
  $http: any
  i = 0;
  created() {
    this.refresh();
  }

  getpage(finishCallback: Function): void {
    schoolService
      .getAll(
        this.request.name,
        this.request.sorting,
        this.request.isHaveSignCode,
        this.request.skipCount,
        this.request.maxResultCount
      )
      .then(result => {
        result.items.forEach(e => {
          e.signBarCodeImg = (this as any).$aes.imgAddAuth(e.signBarCodeImg)
        })
        this.list = result.items;
        this.showPaging(result);
      })
      .finally(() => {
        finishCallback();
      });
  }
  updateSignCodeImg(row) {
    this.currentTenant = row;
    this.dialogVisible = true;
  }
  handleClose() {
    this.dialogVisible = false;
  }

  downloadAllImage() {
    this.i = 0;
    schoolService
      .getAll(
        this.request.name,
        this.request.sorting,
        true,
        0,
        1000
      )
      .then(async result => {
        result.items.forEach(e => {
          e.signBarCodeImg = (this as any).$aes.imgAddAuth(e.signBarCodeImg)
        })
        if (result.totalCount > 0) {
          await this.downloadAllImages(result.items)
        } else {
          this.$message.error("没有二维码可以下载");
        }
      })
      .finally(() => {
        this.$message.success("下载完成");
      });
  }

  async downloadAllImages(imageUrls, delay = 500) {
    for (let i = 0; i < imageUrls.length; i++) {
      try {
        await this.downloadImage(imageUrls[i].signBarCodeImg, imageUrls[i].name);
        // 添加延迟以避免请求过于频繁
        if (i < imageUrls.length - 1) {
          await new Promise(resolve => setTimeout(resolve, delay));
        }
      } catch (error) {
        console.error(`下载 ${imageUrls[i]} 失败:`, error);
        // 可以继续尝试下一个或记录失败
      }
    }
  }



  async downloadImage(imageUrl, fileName) {
    if (!imageUrl) return;
    if (imageUrl.indexOf("https://") == -1) {
      imageUrl = imageUrl.replace("http://", "https://");
    }
    try {
      const response = await fetch(imageUrl, {
        mode: 'cors', // 尝试不同的mode,
        headers: {
          'Origin': window.location.origin
        }
      });
      if (!response.ok) {
        throw new Error(`HTTP错误! 状态码: ${response.status}`);
      }

      const blob = await response.blob();
      if (blob.size === 0) {
        throw new Error('获取的Blob为空');
      }

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 500);

    } catch (error) {
      console.error('下载失败___________-----____________:' + imageUrl);
    } finally {
    }
  }

  submitSchoolSignCode() {
    this.currentTenant.signBarCodeImg = (this as any).$aes.imgDelAuth(this.currentTenant.signBarCodeImg)
    schoolService.updateSchoolSignCode(this.currentTenant)
      .then((res) => {
        this.currentTenant.signBarCodeImg = (this as any).$aes.imgAddAuth(this.currentTenant.signBarCodeImg)
        this.$message.success("修改成功");
        this.dialogVisible = false;
        this.getpage;
      })
      .catch(e => {
        this.$message.error("修改失败")
      })
  }

  handleFaceUpladSuccess(url) {
    this.currentTenant.signBarCodeImg = (this as any).$aes.imgAddAuth(url)
  }

  handleCreate(row:TenantDto|null) {
    // this.$router.push({ path: `/multi-tenancy/tenant/create/${row}`});
    this.$router.push({name:'CreateTenant',params:{row:JSON.stringify(row)}})
  }
  // handleUpdate(tenant: TenantDto) {
  //   this.$router.push({ path: `/multi-tenancy/tenant/update/${tenant.id}` });
  // }
  handleDelete(tenant: TenantDto) {
    this.$confirm("确定删除学校?")
      .then(async () => {
        await schoolService.delete(tenant.id);
        this.$notify.success("删除成功");
        this.refresh();
      })
      .catch(() => { });
  }


  haikangBangding(tenant: TenantDto) {
    this.$message.success("指令已下发，半分钟左右请刷新列表");
    axios
      .get(
        appconst.remoteServiceBaseUrl + "/admin/api/services/app/HaiKangFaceDevice/GetSchoolAsync?SchooID=" + tenant.id
      )
      .then((res) => {

      })
      .catch(() => {
        this.getpage
      })
      .finally(() => {
        this.getpage
      });

  }
}
